'use strict';

module.exports = function (ngModule) {
    ngModule.controller('manageUserController', require('./manage_users'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/users/index.js
 **/